import { Controller } from "stimulus"

export default class extends Controller {
  hideReview(event) {
    event.preventDefault()
    this.element.remove()
  }

  submitReviewedConsentForm(event) {
    event.preventDefault()
    document.dispatchEvent(new CustomEvent("consent-review:confirmed"))
  }
}
